export default __webpack_public_path__ + "static/Tek_Sword-aec58751d1f3247b64c561146b4e24fa.png";